import { z } from 'zod'

export const systemNameSchema = z
	.string()
	.min(3, 'Min length 3 characters')
	.max(32, 'Max length 32 characters')
	.regex(/^[a-z0-9._-]+$/, 'Invalid: only a-z and symbols: . - _')

export const createCategorySchema = z.object({
	name: systemNameSchema,
	friendlyName: z
		.string()
		.min(3, 'Min length 3 characters')
		.max(64, 'Max length 64 characters')
		.refine((value) => value?.trim()?.length, 'Required'),
	description: z.string().optional(),
	prompt: z.string().refine((value) => value?.trim()?.length, 'Required'),
	rules: z.string().optional(),
	promptDescription: z.string().optional(),
})

export const editCategorySchema = createCategorySchema.omit({ name: true })

export type CategoryFormData = z.infer<typeof createCategorySchema>
